import { j as i, a as c } from "../../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { I as o } from "../../../../../Icon-IZV2yalv.js";
import { I as n } from "../../../../../FeatureFlagProvider-C_WBizLB.js";
import "react";
import "@ionic/react";
import { translate as e } from "../../../../string-table.js";
import "../../../../../react-paginate-Lh5zQzpz.js";
import { Section as p } from "../Section/Section.js";
import "../../../LoadingInterstitial/LoadingInterstitial.js";
import "../../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
function u(s) {
  const {
    qualifications: a,
    isSwingHero: I,
    skillBuilderCompletedTasks: m = []
  } = s;
  return /* @__PURE__ */ i(p, {
    title: e("SUB_PROFILE_QUALIFICATIONS_HEADER"),
    children: /* @__PURE__ */ c("div", {
      css: {
        marginTop: 8
      },
      children: [I && /* @__PURE__ */ i(n, {
        leftIcon: /* @__PURE__ */ i(o, {
          name: "Swing Hero"
        }),
        content: `${e("SUB_PROFILE_CONTACT_SWING")} ${e("SUB_PROFILE_CONTACT_HERO")}`,
        hasDivider: !0
      }), a.map((r, t) => /* @__PURE__ */ i("div", {
        children: /* @__PURE__ */ i(n, {
          leftIcon: /* @__PURE__ */ i(o, {
            name: "Verified"
          }),
          content: /* @__PURE__ */ i("span", {
            children: r
          }),
          hasDivider: !0
        })
      }, `${t}-${r}`)), m.length > 0 && m.map((r, t) => /* @__PURE__ */ i("div", {
        children: /* @__PURE__ */ i(n, {
          leftIcon: /* @__PURE__ */ i(o, {
            name: "Lesson"
          }),
          content: `${r} (${e("SUB_PROFILE_QUALIFICATIONS_SKILL_BUILDER_SUB_LABEL")})`,
          hasDivider: !0
        })
      }, `${t}-${r}`))]
    })
  });
}
export {
  u as Qualifications
};
